import { api, BACKEND_URL } from "./client";

export function createWS({ onEvent, onOpen, onStatus }) {
  let ws = null;
  let attempts = 0;
  let closed = false;
  let timer = null;
  const url = BACKEND_URL.replace(/^http/, "ws") + "/api/ws";

  const schedule = (ms) => {
    clearTimeout(timer);
    timer = setTimeout(connect, ms);
  };

  const connect = () => {
    if (closed) return;
    try {
      ws = new WebSocket(url);
    } catch {
      schedule(Math.min(30000, 1000 * Math.pow(2, attempts++)));
      return;
    }
    ws.onopen = () => {
      attempts = 0;
      onStatus && onStatus("open");
      onOpen && onOpen();
    };
    ws.onmessage = (e) => {
      try {
        onEvent(JSON.parse(e.data));
      } catch {}
    };
    ws.onclose = async (e) => {
      if (closed) return;
      onStatus && onStatus("closed");
      if (e.code === 4401) {
        try {
          await api.post("/auth/refresh");
        } catch {}
        schedule(500);
      } else if (e.code === 4403) {
        closed = true;
      } else {
        schedule(Math.min(30000, 1000 * Math.pow(2, attempts++)));
      }
    };
  };

  connect();

  return {
    send: (event, data) => {
      if (ws && ws.readyState === 1) {
        ws.send(JSON.stringify({ event, data }));
        return true;
      }
      return false;
    },
    close: () => {
      closed = true;
      clearTimeout(timer);
      try {
        ws && ws.close();
      } catch {}
    },
  };
}
